import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  IconButton,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Grid,
  Typography,
  Select,
  InputLabel,
  FormControl,
  Checkbox,
  FormHelperText,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Paper,
} from "@mui/material";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CloseIcon from "@mui/icons-material/Close";
import { Delete, UploadFile } from "@mui/icons-material";
import {
  GoogleMap,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";
import {
  validateName,
  validateShopName,
  validateEmail,
  validatePhoneNumber,
  validateDropdown,
  validateDropdownForArray,
  validateDOB,
  validateAadhar,
  validatePAN,
  validateGST,
  validateCountry,
  validateState,
  validateCity,
  validateStreet,
  validateLandmark,
  validatePincode,
} from "../../../utils/textFieldValidations";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { urls } from "../../../urls/urls";
import { useFetch, useUpdate } from "../../../hooks";
import {
  convertDate,
  convertDateToDateMonthYear,
  convertDateFormat,
} from "../../../utils/DateFormats";
import { styled } from "@mui/system";
import AppHeaderBar from "../../../components/AppBar/appBar";
import { useNavigate } from "react-router-dom";

const ProfilePage = ({ onBackScreenName }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const imageInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [selectedStoreImageFile, setSelectedStoreImageFile] = useState(null);
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [natureData, setNatureData] = useState([]);
  const [moduleStatusData, setModuleStatusData] = useState({});
  const [categoryData, setCategoryData] = useState({});
  const [listingCategoryData, setListingCategoryData] = useState({});
  const [id, setId] = useState(4);
  const [data, setData] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });

  const [vendorData, setVendorData] = useState({
    name: "",
    shopName: "",
    location: "",
    email: "",
    phoneNumber: "",
    businessNature: "",
    status: "",
    category: [] || "",
    profilePhoto: "",
    storeImage: "",
    openingTime: "",
    eveningTime: "",
    dob: "",
    aadhar: "",
    pan: "",
    gst: "",
    country: "",
    state: "",
    city: "",
    street: "",
    landmark: "",
    pincode: "",
    searchlocation: "",
    latitude: "",
    longitude: "",
    password: "",
    id: "",
    productType: "",
    listingCategory: [] || "",
  });

  const loginToken = useSelector((state) => state.user.logintoken);
  const libraries = ["places"];
  const statusURL = BASE_URL_TEST + urls("getStatusById", id);
  const userDetails = useSelector((state) => state.user.userdetails);
  const vendorId = userDetails?.vtype === "vendor" ? userDetails["id"] : null;
  const userId = userDetails?.vtype === "user" ? userDetails["user_id"] : null;
  const listingId =
    userDetails?.vtype === "vlistuser" ? userDetails["id"] : null;

  const useGoogleMaps = () => {
    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8",
      libraries,
    });
    return { isLoaded, loadError };
  };

  const { isLoaded, loadError } = useGoogleMaps();
  // Get all vendors data to find current vendor
  const {
    data: vendorsData,
    isLoading: isVendorsLoading,
    error: vendorsError,
    fetchData: fetchVendorsData,
  } = useFetch(BASE_URL_TEST + urls("getAllVendors"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  // Fetch business nature data
  const {
    data: businessNatureData,
    isLoading: isbusinessNatureLoading,
    error: businessNatureError,
    fetchData: fetchBusinessNatureData,
  } = useFetch(BASE_URL_TEST + urls("getAllBNature"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Fetch status data
  const {
    data: allStatusData,
    isLoading: isStatusLoading,
    error: statusError,
    fetchData: fetchStatus,
  } = useFetch(statusURL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Fetch categories data
  const {
    data: allCategoryData,
    isLoading: isCategoryLoading,
    error: categoryError,
    fetchData: fetchCategory,
  } = useFetch(BASE_URL_TEST + urls("getAllCategories"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Fetch listing categories data
  const {
    data: allListingCategoryData,
    isLoading: isListingCategoryLoading,
    error: listingCategoryError,
    fetchData: fetchListingCategory,
  } = useFetch(BASE_URL_TEST + urls("getAllListing"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateVendorsData,
    isLoading: updateVendorsLoading,
    error: updateVendorsError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // ALL useEffect hooks MUST come before any conditional returns
  useEffect(() => {
    fetchVendorsData();
    fetchBusinessNatureData();
    fetchStatus();
  }, []);

  useEffect(() => {
    if (vendorData?.productType === "regular") {
      fetchCategory();
    } else if (vendorData?.productType === "listing") {
      fetchListingCategory();
    }
  }, [vendorData?.productType]);

  // Business nature useEffect
  useEffect(() => {
    if (businessNatureError) {
    } else if (businessNatureData && businessNatureData["status"] === true) {
      setNatureData(businessNatureData["data"]);
    }
  }, [businessNatureData, businessNatureError]);

  // Get status useEffect
  useEffect(() => {
    if (statusError) {
    } else if (allStatusData && allStatusData["status"] === true) {
      setModuleStatusData(allStatusData["data"]);
    }
  }, [allStatusData, statusError]);

  // Set vendors data when fetched
  useEffect(() => {
    if (vendorsError) {
      console.error("Error fetching vendors:", vendorsError);
    } else if (vendorsData && vendorsData["status"] === true) {
      setData(vendorsData["data"]);
    }
  }, [vendorsData, vendorsError]);

  // Load current vendor profile data
  useEffect(() => {
    const loadVendorProfile = async () => {
      if (data && data.length > 0 && (vendorId || listingId)) {
        let currentVendor = null;

        if (vendorId != null) {
          currentVendor = data.find((v) => v.id === vendorId);
        } else if (listingId != null) {
          currentVendor = data.find((v) => v.id === listingId);
        }
        if (currentVendor) {
          let categoryIds = [];
          let listingcategoryIds = [];

          if (currentVendor.categories) {
            categoryIds = currentVendor.categories.map(
              (category) => category.category_id,
            );
          }

          if (currentVendor.listCategories) {
            listingcategoryIds = currentVendor.listCategories.map(
              (listingcategory) => listingcategory.category_id,
            );
          }

          setVendorData({
            name: currentVendor["name"] || "",
            shopName: currentVendor["shop_name"] || "",
            location: currentVendor["location"] || "",
            email: currentVendor["email"] || "",
            phoneNumber: currentVendor["phone_number"] || "",
            businessNature: currentVendor["business_id"] || "",
            status: currentVendor["status"] || "",
            category: categoryIds,
            listingCategory: listingcategoryIds,
            profilePhoto: currentVendor["profile"] || "",
            storeImage: currentVendor["store_image"] || "",
            openingTime: currentVendor["open_time"] || "",
            eveningTime: currentVendor["close_time"] || "",
            dob: currentVendor["dob"]
              ? convertDateFormat(currentVendor["dob"])
              : null,
            aadhar: currentVendor["aadhar"] || "",
            pan: currentVendor["pancard"] || "",
            gst: currentVendor["gstn_no"] || "",
            country: currentVendor["country"] || "",
            state: currentVendor["state"] || "",
            city: currentVendor["city"] || "",
            street: currentVendor["street"] || "",
            landmark: currentVendor["landmark"] || "",
            pincode: currentVendor["pincode"] || "",
            latitude: currentVendor["latitude"] || "",
            longitude: currentVendor["longitude"] || "",
            id: currentVendor["id"],
            productType: currentVendor["reg_list_type"] || "",
          });

          // Reverse geocode to get address
          if (currentVendor.latitude && currentVendor.longitude) {
            try {
              const reverseGeocodeResponse = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${currentVendor.latitude},${currentVendor.longitude}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
              );
              const reverseGeocodeData = await reverseGeocodeResponse.json();

              if (
                reverseGeocodeData.results &&
                reverseGeocodeData.results.length > 0
              ) {
                const address = reverseGeocodeData.results[0].formatted_address;

                setVendorData((prevData) => ({
                  ...prevData,
                  searchlocation: address,
                }));
              }

              // Update map position after a short delay
              setTimeout(() => {
                if (mapRef.current) {
                  const map = mapRef.current;
                  const center = {
                    lat: parseFloat(currentVendor.latitude),
                    lng: parseFloat(currentVendor.longitude),
                  };
                  map.panTo(center);
                  map.setZoom(15);
                }

                if (markerRef.current) {
                  markerRef.current.setPosition({
                    lat: parseFloat(currentVendor.latitude),
                    lng: parseFloat(currentVendor.longitude),
                  });
                }
              }, 500);
            } catch (error) {
              console.error("Error fetching location:", error);
            }
          }
        }
      }
    };

    loadVendorProfile();
  }, [data, userId]);

  // Update vendor useEffect
  useEffect(() => {
    if (updateVendorsError) {
    } else if (updateVendorsData && updateVendorsData["status"] === true) {
      setSnackbarState({
        message: updateVendorsData["message"],
        status: updateVendorsData["status"],
      });
      setModalOpen(true);
      // Refresh vendor data after successful update
      fetchVendorsData(); // ADD THIS LINE
    } else if (updateVendorsData && updateVendorsData["status"] === false) {
      setSnackbarState({
        message: updateVendorsData["message"],
        status: updateVendorsData["status"],
      });
      setModalOpen(true);
    }
  }, [updateVendorsData, updateVendorsError]);

  useEffect(() => {
    if (navigator.geolocation && !vendorData.latitude) {
      // ADD && !vendorData.latitude
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setVendorData((prevData) => ({
          ...prevData,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  // Get categories useEffect
  useEffect(() => {
    if (categoryError) {
    } else if (allCategoryData && allCategoryData["status"] === true) {
      const filteredCategories = allCategoryData["data"].filter(
        (item) => item.status === 1,
      );
      setCategoryData(filteredCategories);
    }
  }, [allCategoryData, categoryError]);

  // Get listing categories useEffect
  useEffect(() => {
    if (listingCategoryError) {
    } else if (
      allListingCategoryData &&
      allListingCategoryData["status"] === true
    ) {
      const filteredListingCategories = allListingCategoryData["data"].filter(
        (item) => item.status === 1,
      );
      setListingCategoryData(filteredListingCategories);
    }
  }, [allListingCategoryData, listingCategoryError]);

  // Update vendor useEffect

  useEffect(() => {
    if (updateVendorsError) {
    } else if (updateVendorsData && updateVendorsData["status"] === true) {
      setSnackbarState({
        message: updateVendorsData["message"],
        status: updateVendorsData["status"],
      });
      setModalOpen(true);
      setSelectedProfileFile(null);
      setSelectedStoreImageFile(null);
      setSelectedFiles([]);

      fetchVendorsData();
    } else if (updateVendorsData && updateVendorsData["status"] === false) {
      setSnackbarState({
        message: updateVendorsData["message"],
        status: updateVendorsData["status"],
      });
      setModalOpen(true);
    }
  }, [updateVendorsData, updateVendorsError]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setVendorData((vendorData) => ({
          ...vendorData,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  // Handle Google Maps loading states AFTER all hooks
  if (loadError) {
    return <Box sx={{ p: 3 }}>Error loading Google Maps</Box>;
  }

  if (!isLoaded) {
    return <Box sx={{ p: 3 }}>Loading Google Maps...</Box>;
  }

  const clearErrors = () => {
    setErrors({});
  };

  const StyledPaper = styled(Paper)({
    padding: "16px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#fff",
  });

  const validateImageFile = (
    file,
    maxSizeKB,
    requiredWidth,
    requiredHeight,
  ) => {
    return new Promise((resolve, reject) => {
      const fileSizeKB = file.size / 1024;
      if (fileSizeKB > maxSizeKB) {
        reject(
          `File size should be less than ${maxSizeKB}KB. Current size: ${Math.round(
            fileSizeKB,
          )}KB`,
        );
        return;
      }

      if (!file.type.match(/image\/(jpeg|jpg|png)/)) {
        reject("Only JPEG and PNG images are allowed");
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        URL.revokeObjectURL(objectUrl);
        if (img.width !== requiredWidth || img.height !== requiredHeight) {
          reject(
            `Image dimensions should be ${requiredWidth}x${requiredHeight}. Current: ${img.width}x${img.height}`,
          );
        } else {
          resolve(true);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject("Error loading image");
      };

      img.src = objectUrl;
    });
  };

  const handleProfileImage = async (e) => {
    const file = e.target.files[0];

    if (file) {
      try {
        await validateImageFile(file, 40, 300, 300);
        setVendorData((prevData) => ({
          ...prevData,
          profilePhoto: URL.createObjectURL(file),
        }));
        setSelectedProfileFile(file);
        if (errors.profilePhoto) {
          setErrors((prev) => ({ ...prev, profilePhoto: "" }));
        }
      } catch (error) {
        setErrors((prev) => ({ ...prev, profilePhoto: error }));
        e.target.value = null;
      }
    }
  };

  const handleStoreImage = async (e) => {
    const file = e.target.files[0];

    if (file) {
      try {
        await validateImageFile(file, 60, 1250, 400);
        setVendorData((prevData) => ({
          ...prevData,
          storeImage: URL.createObjectURL(file),
        }));
        setSelectedStoreImageFile(file);
        if (errors.storeImage) {
          setErrors((prev) => ({ ...prev, storeImage: "" }));
        }
      } catch (error) {
        setErrors((prev) => ({ ...prev, storeImage: error }));
        e.target.value = null;
      }
    }
  };

  const ImageItem = ({ name, error, onRemove }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1,
        border: "1px solid #ddd",
        borderRadius: "4px",
      }}
    >
      <img
        src={name}
        alt="Product thumbnail"
        style={{
          width: "50px",
          height: "50px",
          marginRight: "8px",
          objectFit: "cover",
        }}
      />
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body2" color="textSecondary">
          {name}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={100}
          sx={{
            height: "6px",
            borderRadius: "2px",
            mt: 1,
            backgroundColor: "inherit",
            "& .MuiLinearProgress-bar": {
              backgroundColor: error ? "red" : "green",
            },
          }}
        />
      </Box>
      <IconButton onClick={onRemove} sx={{ ml: 1 }}>
        <CloseIcon />
      </IconButton>
    </Box>
  );

  const handleLocationSearch = async (e) => {
    const searchValue = e.target.value;
    setVendorData({
      ...vendorData,
      searchlocation: searchValue,
    });

    const query = `${vendorData["country"]}, ${vendorData["state"]}, ${searchValue}`;

    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          query,
        )}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
      );

      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;

        setVendorData((prevData) => ({
          ...prevData,
          latitude: lat,
          longitude: lng,
        }));

        if (mapRef.current) {
          mapRef.current.setCenter({ lat, lng });
          mapRef.current.setZoom(15);
        }
        if (markerRef.current) {
          markerRef.current.setPosition({ lat, lng });
        }
      } else {
        console.log("No results found.");
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  const handleSubmit = () => {
    let validationErrors = {};

    if (!validateName(vendorData.name)) {
      validationErrors.name =
        "Name is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateShopName(vendorData.shopName)) {
      validationErrors.shopName =
        "Shop Name is required and can contain letters, numbers, spaces, hyphens, and apostrophes.";
      setErrors(validationErrors);
      return;
    }

    if (!validateCity(vendorData.location)) {
      validationErrors.location =
        "Location is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateEmail(vendorData.email)) {
      validationErrors.email = "Please enter a valid email address.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePhoneNumber(vendorData.phoneNumber)) {
      validationErrors.phoneNumber = "Please enter a 10 digit phone number.";
      setErrors(validationErrors);
      return;
    }

    if (!vendorData.productType) {
      validationErrors.productType = "Please select product type.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDropdownForArray(vendorData.businessNature)) {
      validationErrors.businessNatureDropdown =
        "Please select business nature.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDropdownForArray(vendorData.status)) {
      validationErrors.statusDropdown = "Please select status.";
      setErrors(validationErrors);
      return;
    }

    if (vendorData?.productType === "regular") {
      if (!validateDropdownForArray(vendorData.category)) {
        validationErrors.categoryDropdown = "Please select category.";
        setErrors(validationErrors);
        return;
      }
    } else if (vendorData?.productType === "listing") {
      if (!validateDropdownForArray(vendorData.listingCategory)) {
        validationErrors.listingCategoryDropdown =
          "Please select Listing Category.";
        setErrors(validationErrors);
        return;
      }
    }

    if (!vendorData.profilePhoto) {
      validationErrors.profilePhoto =
        "Store Image is required. Please upload an image (300x300, Max 40KB).";
      setErrors(validationErrors);
      return false;
    }

    if (!vendorData.storeImage) {
      validationErrors.storeImage =
        "Store Banner is required. Please upload an image (1250x400, Max 60KB).";
      setErrors(validationErrors);
      return false;
    }

    if (!validateDropdownForArray(vendorData.openingTime)) {
      validationErrors.openingTimeDropdown = "Please select opening time.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDropdownForArray(vendorData.eveningTime)) {
      validationErrors.eveningTimeDropDown = "Please select evening time.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDOB(vendorData.dob)) {
      validationErrors.dob = "Date of birth is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validateAadhar(vendorData.aadhar)) {
      validationErrors.aadhar = "Aadhar number must be a 12-digit number.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePAN(vendorData.pan)) {
      validationErrors.pan = "Please enter a valid PAN number.";
      setErrors(validationErrors);
      return;
    }

    if (vendorData.productType === "regular" && !validateGST(vendorData.gst)) {
      validationErrors.gst = "Please enter a valid GST number.";
      setErrors(validationErrors);
      return;
    }

    if (!validateCountry(vendorData.country)) {
      validationErrors.country =
        "Country is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateState(vendorData.state)) {
      validationErrors.state =
        "State is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateStreet(vendorData.street)) {
      validationErrors.street =
        "Street Address is required and can contain letters, numbers, spaces, commas, periods, hyphens, and hashes.";
      setErrors(validationErrors);
      return;
    }

    if (!validateLandmark(vendorData.landmark)) {
      validationErrors.landmark = "Landmark is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePincode(vendorData.pincode)) {
      validationErrors.pincode = "Pincode should be a 6-digit number.";
      setErrors(validationErrors);
      return;
    }

    if (!validateLandmark(vendorData.searchlocation)) {
      validationErrors.searchlocation = "Location is required.";
      setErrors(validationErrors);
      return;
    }

    clearErrors();

    const months = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    let aadharPrefix = vendorData.aadhar.slice(0, 2);
    const covertDate = vendorData.dob ? convertDate(vendorData.dob) : null;
    let dobMonth = covertDate.split("-")[1];
    let dobMonthAbbr = months[parseInt(dobMonth, 10) - 1];
    let dobMonthWithAt = `${dobMonthAbbr}@`;
    let dobYear = covertDate.split("-")[0];
    let dobYearLastTwo = dobYear.slice(2);
    let password = `${aadharPrefix}${dobMonthWithAt}${dobYearLastTwo}`;

    const formdata = new FormData();
    formdata.append("name", vendorData["name"]);
    formdata.append("shop_name", vendorData["shopName"]);
    formdata.append("location", vendorData["location"]);
    formdata.append("email", vendorData["email"]);
    formdata.append("phone_number", vendorData["phoneNumber"]);
    formdata.append("business_id", vendorData["businessNature"]);
    formdata.append("status", vendorData["status"]);

    if (vendorData?.productType === "regular") {
      formdata.append("category_id", vendorData["category"]);
    }
    if (vendorData?.productType === "listing") {
      formdata.append("category_id", vendorData["listingCategory"]);
    }

    formdata.append(
      "profile",
      selectedProfileFile ? selectedProfileFile : vendorData["profile"],
    );
    formdata.append(
      "store_image",
      selectedStoreImageFile
        ? selectedStoreImageFile
        : vendorData["storeImage"],
    );
    formdata.append("open_time", vendorData["openingTime"]);
    formdata.append("close_time", vendorData["eveningTime"]);
    formdata.append(
      "dob",
      vendorData.dob ? convertDateToDateMonthYear(vendorData.dob) : null,
    );
    formdata.append("aadhar", vendorData["aadhar"]);
    formdata.append("pancard", vendorData["pan"]);
    formdata.append("gstn_no", vendorData["gst"]);
    formdata.append("country", vendorData["country"]);
    formdata.append("state", vendorData["state"]);
    formdata.append("city", vendorData["location"]);
    formdata.append("street", vendorData["street"]);
    formdata.append("landmark", vendorData["landmark"]);
    formdata.append("pincode", vendorData["pincode"]);
    formdata.append("latitude", vendorData["latitude"]);
    formdata.append("longitude", vendorData["longitude"]);
    formdata.append("password", password);

    if (vendorData.productType === "regular") {
      formdata.append("reg_list_type", "regular");
    } else if (vendorData.productType === "listing") {
      formdata.append("reg_list_type", "listing");
    }

    const updateUrl = urls("updateVendor", vendorData["id"]);
    fetchUpdateData(updateUrl, formdata);
  };

  const handleClose = () => {
    setModalOpen(false);
    clearErrors();
    setSnackbarState({
      message: "",
      status: "",
    });
    if (updateVendorsData && updateVendorsData["status"] === true) {
      navigate("/sal");
    }
  };

  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  const createRedIcon = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      return {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
    return null;
  };

  const LocationPicker = ({ setLatitude, setLongitude }) => {
    const handleMapClick = (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          setLatitude(lat);
          setLongitude(lng);
        }
      });
    };
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        p: 2,
        bgcolor: "#EEF2FF",
      }}
    >
      <AppHeaderBar title="Vendor Profile" onBackScreenName={handleScreeName} />

      <Box
        sx={{
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
          Profile Information
        </Typography>

        {/* Basic Information */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            value={vendorData?.name || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, name: e.target.value })
            }
            error={!!errors.name}
            helperText={errors.name}
          />
          <TextField
            margin="dense"
            label="Shop Name"
            type="text"
            fullWidth
            value={vendorData?.shopName || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, shopName: e.target.value })
            }
            error={!!errors.shopName}
            helperText={errors.shopName}
          />
          <TextField
            margin="dense"
            label="Location"
            type="text"
            fullWidth
            value={vendorData?.location || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, location: e.target.value })
            }
            error={!!errors.location}
            helperText={errors.location}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <TextField
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            value={vendorData?.email || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, email: e.target.value })
            }
            error={!!errors.email}
            helperText={errors.email}
          />
          <TextField
            margin="dense"
            label="Phone"
            type="tel"
            fullWidth
            value={vendorData?.phoneNumber || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, phoneNumber: e.target.value })
            }
            error={!!errors.phoneNumber}
            helperText={errors.phoneNumber}
          />
        </Box>

        {/* Product Type */}
        <FormControl component="fieldset" sx={{ marginTop: 2 }}>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            Product Type
          </Typography>
          <RadioGroup
            row
            name="productType"
            value={vendorData?.productType || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, productType: e.target.value })
            }
          >
            <FormControlLabel
              value="regular"
              control={<Radio />}
              label="Sthanick Stores"
            />
            <FormControlLabel
              value="listing"
              control={<Radio />}
              label="Sthanick Services"
            />
          </RadioGroup>
          {errors.productType && (
            <FormHelperText error>{errors.productType}</FormHelperText>
          )}
        </FormControl>

        {/* Dropdowns */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <FormControl fullWidth margin="dense">
            <InputLabel id="businessnature-label">Business Nature</InputLabel>
            <Select
              labelId="businessnature-label"
              value={vendorData?.businessNature || ""}
              error={!!errors.businessNatureDropdown}
              onChange={(e) =>
                setVendorData({
                  ...vendorData,
                  businessNature: e.target.value,
                })
              }
              label="Business Nature"
            >
              {natureData && natureData.length > 0 ? (
                natureData.map((businessNature) => (
                  <MenuItem
                    key={businessNature.business_id}
                    value={businessNature.business_id}
                  >
                    {businessNature.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No business nature available</MenuItem>
              )}
            </Select>
            {errors.businessNatureDropdown && (
              <FormHelperText error>
                {errors.businessNatureDropdown}
              </FormHelperText>
            )}
          </FormControl>

          <FormControl fullWidth margin="dense">
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              value={vendorData?.status || ""}
              error={!!errors.statusDropdown}
              onChange={(e) =>
                setVendorData({
                  ...vendorData,
                  status: e.target.value,
                })
              }
              label="Status"
            >
              {moduleStatusData &&
              typeof moduleStatusData.options === "string" ? (
                moduleStatusData.options.split(",").map((option, index) => (
                  <MenuItem key={index} value={option.trim()}>
                    {option.trim()}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No status data available</MenuItem>
              )}
            </Select>
            {errors.statusDropdown && (
              <FormHelperText error>{errors.statusDropdown}</FormHelperText>
            )}
          </FormControl>

          {vendorData?.productType === "regular" && (
            <FormControl fullWidth margin="dense">
              <InputLabel id="category-label">Category</InputLabel>
              <Select
                labelId="category-label"
                multiple
                value={
                  Array.isArray(vendorData?.category) ? vendorData.category : []
                }
                error={!!errors.categoryDropdown}
                onChange={(e) => {
                  const selectedCategories = e.target.value;
                  setVendorData({
                    ...vendorData,
                    category: Array.isArray(selectedCategories)
                      ? selectedCategories
                      : [],
                  });
                }}
                renderValue={(selected) => {
                  if (selected.length === 0) return "Select Categories";
                  const categoriesToDisplay = Array.isArray(categoryData)
                    ? categoryData.filter((category) =>
                        selected.includes(category.category_id),
                      )
                    : [];
                  return categoriesToDisplay
                    .map((category) => category.name)
                    .join(", ");
                }}
                label="Category"
              >
                {Array.isArray(categoryData) && categoryData.length > 0 ? (
                  categoryData.map((category) => (
                    <MenuItem
                      key={category.category_id}
                      value={category.category_id}
                    >
                      <Checkbox
                        checked={
                          Array.isArray(vendorData?.category) &&
                          vendorData?.category.includes(category.category_id)
                        }
                      />
                      {category.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No categories available</MenuItem>
                )}
              </Select>
              {errors.categoryDropdown && (
                <FormHelperText error>{errors.categoryDropdown}</FormHelperText>
              )}
            </FormControl>
          )}

          {vendorData?.productType === "listing" && (
            <FormControl fullWidth margin="dense">
              <InputLabel id="listing-category-label">
                Listing Category
              </InputLabel>
              <Select
                labelId="listing-category-label"
                multiple
                value={
                  Array.isArray(vendorData?.listingCategory)
                    ? vendorData.listingCategory
                    : []
                }
                error={!!errors.listingCategoryDropdown}
                onChange={(e) => {
                  const selectedCategories = e.target.value;
                  setVendorData({
                    ...vendorData,
                    listingCategory: Array.isArray(selectedCategories)
                      ? selectedCategories
                      : [],
                  });
                }}
                renderValue={(selected) => {
                  if (selected.length === 0) return "Select Listing Categories";
                  const selectedCategories = Array.isArray(listingCategoryData)
                    ? listingCategoryData.filter((category) =>
                        selected.includes(category.category_id),
                      )
                    : [];
                  return selectedCategories
                    .map((category) => category.name)
                    .join(", ");
                }}
                label="Listing Category"
              >
                {Array.isArray(listingCategoryData) &&
                listingCategoryData.length > 0 ? (
                  listingCategoryData.map((category) => (
                    <MenuItem
                      key={category.category_id}
                      value={category.category_id}
                    >
                      <Checkbox
                        checked={
                          Array.isArray(vendorData?.listingCategory) &&
                          vendorData?.listingCategory.includes(
                            category.category_id,
                          )
                        }
                      />
                      {category.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No listing categories available</MenuItem>
                )}
              </Select>
              {errors.listingCategoryDropdown && (
                <FormHelperText error>
                  {errors.listingCategoryDropdown}
                </FormHelperText>
              )}
            </FormControl>
          )}
        </Box>

        {/* Profile Photo Section */}
        <Grid container spacing={2} sx={{ mb: 4, mt: 2 }} alignItems="center">
          <Grid item xs={12} sm={3}>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
              Store Image (Either Front or inside store image)
            </Typography>
            <Avatar
              alt="Image"
              src={vendorData?.profilePhoto || "/default-profile.png"}
              sx={{
                width: 150,
                height: 150,
                border: "2px solid #ddd",
                mb: 1,
                borderRadius: 0,
              }}
            />
            <Typography variant="body2" color="textSecondary" marginTop={1}>
              Required: 300 × 300 pixels
            </Typography>
            <Typography variant="caption" color="textSecondary" display="block">
              Max size: 40KB (JPEG/PNG)
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Button
              variant="contained"
              component="label"
              startIcon={<UploadFile />}
              sx={{
                mr: 2,
                bgcolor: "#3f51b5",
                "&:hover": { bgcolor: "#303f9f" },
              }}
            >
              Upload Image
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={handleProfileImage}
              />
            </Button>

            <Button
              variant="outlined"
              startIcon={<Delete />}
              onClick={() => {
                setVendorData((prevData) => ({
                  ...prevData,
                  profilePhoto: "",
                }));
              }}
              sx={{
                color: "#f44336",
                borderColor: "#f44336",
                "&:hover": { bgcolor: "#ffe6e6" },
              }}
            >
              Delete
            </Button>
            {errors.profilePhoto && (
              <Typography
                sx={{
                  mt: 2,
                  color: "red",
                  fontWeight: "bold",
                  fontSize: 12,
                }}
              >
                {errors.profilePhoto}
              </Typography>
            )}
          </Grid>
        </Grid>

        {/* Store Banner Section */}
        <Box sx={{ mt: 2 }}>
          <StyledPaper sx={{ mb: 2, textAlign: "center" }}>
            {selectedFiles.length > 0 ? (
              <img
                src={URL.createObjectURL(selectedFiles[0])}
                alt="Product"
                style={{ width: "80%" }}
              />
            ) : (
              <img
                src={vendorData?.storeImage || "/placeholder.jpg"}
                alt="Placeholder"
                style={{ width: "30%" }}
              />
            )}
          </StyledPaper>
          {errors.storeImage && (
            <Typography
              sx={{
                mt: 2,
                color: "red",
                fontWeight: "bold",
                fontSize: 12,
              }}
            >
              {errors.storeImage}
            </Typography>
          )}
          <StyledPaper>
            <Typography variant="h6" gutterBottom>
              Store Image (Banner/Flexi, Front side of the store view)
            </Typography>
            <Box
              sx={{
                border: "2px dashed #ddd",
                borderRadius: "4px",
                p: 2,
                textAlign: "center",
                mb: 2,
                cursor: "pointer",
              }}
              onClick={() => imageInputRef.current?.click()}
            >
              <img
                src="/ph_image-light.svg"
                alt="Product"
                style={{ width: "20%" }}
              />
              <Typography variant="h6">Add Store Banner</Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Required: 1250 x 400 pixels
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Max size: 60KB | Format: JPEG, PNG
              </Typography>
              <input
                type="file"
                accept="image/jpeg, image/png"
                multiple
                ref={imageInputRef}
                style={{ display: "none" }}
                onChange={handleStoreImage}
              />
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {selectedFiles.map((file, index) => (
                <ImageItem
                  key={index}
                  name={URL.createObjectURL(file)}
                  error={
                    file.type !== "image/jpeg" && file.type !== "image/png"
                  }
                  onRemove={() => {
                    setSelectedFiles((prevFiles) =>
                      prevFiles.filter((_, i) => i !== index),
                    );
                  }}
                />
              ))}
            </Box>
          </StyledPaper>
        </Box>

        {/* Timing Section */}
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            marginBottom: "20px",
            mt: 2,
            justifyContent: "space-between",
          }}
        >
          <FormControl fullWidth sx={{ flex: 2 }}>
            <Typography sx={{ marginBottom: "8px" }}>Opening Time</Typography>
            <Select
              value={vendorData?.openingTime || ""}
              onChange={(e) =>
                setVendorData({
                  ...vendorData,
                  openingTime: e.target.value,
                })
              }
              error={!!errors.openingTimeDropdown}
              displayEmpty
              sx={{ height: "40px" }}
            >
              <MenuItem value="" disabled>
                Select morning time
              </MenuItem>
              <MenuItem value="12:00 AM">12:00 AM</MenuItem>
              <MenuItem value="12:30 AM">12:30 AM</MenuItem>
              <MenuItem value="01:00 AM">01:00 AM</MenuItem>
              <MenuItem value="01:30 AM">01:30 AM</MenuItem>
              <MenuItem value="02:00 AM">02:00 AM</MenuItem>
              <MenuItem value="02:30 AM">02:30 AM</MenuItem>
              <MenuItem value="03:00 AM">03:00 AM</MenuItem>
              <MenuItem value="03:30 AM">03:30 AM</MenuItem>
              <MenuItem value="04:00 AM">04:00 AM</MenuItem>
              <MenuItem value="04:30 AM">04:30 AM</MenuItem>
              <MenuItem value="05:00 AM">05:00 AM</MenuItem>
              <MenuItem value="05:30 AM">05:30 AM</MenuItem>
              <MenuItem value="06:00 AM">06:00 AM</MenuItem>
              <MenuItem value="06:30 AM">06:30 AM</MenuItem>
              <MenuItem value="07:00 AM">07:00 AM</MenuItem>
              <MenuItem value="07:30 AM">07:30 AM</MenuItem>
              <MenuItem value="08:00 AM">08:00 AM</MenuItem>
              <MenuItem value="08:30 AM">08:30 AM</MenuItem>
              <MenuItem value="09:00 AM">09:00 AM</MenuItem>
              <MenuItem value="09:30 AM">09:30 AM</MenuItem>
              <MenuItem value="10:00 AM">10:00 AM</MenuItem>
              <MenuItem value="10:30 AM">10:30 AM</MenuItem>
              <MenuItem value="11:00 AM">11:00 AM</MenuItem>
              <MenuItem value="11:30 AM">11:30 AM</MenuItem>
            </Select>
            {errors.openingTimeDropdown && (
              <helperText>
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.openingTimeDropdown}
                </Typography>
              </helperText>
            )}
          </FormControl>
          <FormControl fullWidth sx={{ flex: 2 }}>
            <Typography sx={{ marginBottom: "8px" }}>Evening Time</Typography>
            <Select
              value={vendorData?.eveningTime || ""}
              onChange={(e) =>
                setVendorData({
                  ...vendorData,
                  eveningTime: e.target.value,
                })
              }
              error={!!errors.eveningTimeDropDown}
              displayEmpty
              sx={{ height: "40px" }}
            >
              <MenuItem value="" disabled>
                Select evening time
              </MenuItem>
              <MenuItem value="12:00 PM">12:00 PM</MenuItem>
              <MenuItem value="12:30 PM">12:30 PM</MenuItem>
              <MenuItem value="01:00 PM">01:00 PM</MenuItem>
              <MenuItem value="01:30 PM">01:30 PM</MenuItem>
              <MenuItem value="02:00 PM">02:00 PM</MenuItem>
              <MenuItem value="02:30 PM">02:30 PM</MenuItem>
              <MenuItem value="03:00 PM">03:00 PM</MenuItem>
              <MenuItem value="03:30 PM">03:30 PM</MenuItem>
              <MenuItem value="04:00 PM">04:00 PM</MenuItem>
              <MenuItem value="04:30 PM">04:30 PM</MenuItem>
              <MenuItem value="05:00 PM">05:00 PM</MenuItem>
              <MenuItem value="05:30 PM">05:30 PM</MenuItem>
              <MenuItem value="06:00 PM">06:00 PM</MenuItem>
              <MenuItem value="06:30 PM">06:30 PM</MenuItem>
              <MenuItem value="07:00 PM">07:00 PM</MenuItem>
              <MenuItem value="07:30 PM">07:30 PM</MenuItem>
              <MenuItem value="08:00 PM">08:00 PM</MenuItem>
              <MenuItem value="08:30 PM">08:30 PM</MenuItem>
              <MenuItem value="09:00 PM">09:00 PM</MenuItem>
              <MenuItem value="09:30 PM">09:30 PM</MenuItem>
              <MenuItem value="10:00 PM">10:00 PM</MenuItem>
              <MenuItem value="10:30 PM">10:30 PM</MenuItem>
              <MenuItem value="11:00 PM">11:00 PM</MenuItem>
              <MenuItem value="11:30 PM">11:30 PM</MenuItem>
            </Select>
            {errors.eveningTimeDropDown && (
              <helperText>
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.eveningTimeDropDown}
                </Typography>
              </helperText>
            )}
          </FormControl>

          <Box sx={{ flex: 2, mt: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Date of Birth"
                value={vendorData.dob ? new Date(vendorData.dob) : null}
                maxDate={new Date()}
                onChange={(newValue) => {
                  setVendorData({ ...vendorData, dob: newValue });
                  if (newValue) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      dob: null,
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    sx={{ mb: 4 }}
                    error={!!errors.dob}
                  />
                )}
              />
              {errors.dob && (
                <FormHelperText error>{errors.dob}</FormHelperText>
              )}
            </LocalizationProvider>
          </Box>
        </Box>

        {/* Document Details */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            margin="dense"
            label="Aadhar Number"
            type="tel"
            fullWidth
            value={vendorData?.aadhar || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, aadhar: e.target.value })
            }
            error={!!errors.aadhar}
            helperText={errors.aadhar}
          />

          <TextField
            margin="dense"
            label="Pan Number"
            type="tel"
            fullWidth
            value={vendorData?.pan || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, pan: e.target.value })
            }
            error={!!errors.pan}
            helperText={errors.pan}
            placeholder="Example: ABCDE1234F"
          />
          <TextField
            margin="dense"
            label="G.S.T No"
            type="tel"
            fullWidth
            value={vendorData?.gst || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, gst: e.target.value })
            }
            error={!!errors.gst}
            helperText={errors.gst}
            placeholder="Example: 27AAAPA1234A1Z5"
          />
        </Box>

        {/* Address Section */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6">Address</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            margin="dense"
            label="Country"
            type="text"
            fullWidth
            value={vendorData?.country || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, country: e.target.value })
            }
            disabled
            error={!!errors.country}
            helperText={errors.country}
          />

          <TextField
            margin="dense"
            label="State"
            type="text"
            fullWidth
            value={vendorData?.state || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, state: e.target.value })
            }
            disabled
            error={!!errors.state}
            helperText={errors.state}
          />
          <TextField
            margin="dense"
            label="City"
            type="text"
            fullWidth
            value={vendorData?.location || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, city: vendorData?.location })
            }
           disabled
          />
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            margin="dense"
            label="Street Address"
            type="text"
            fullWidth
            value={vendorData?.street || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, street: e.target.value })
            }
           disabled
            error={!!errors.street}
            helperText={errors.street}
          />
          <TextField
            margin="dense"
            label="Land mark"
            type="text"
            fullWidth
            value={vendorData?.landmark || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, landmark: e.target.value })
            }
            disabled
            error={!!errors.landmark}
            helperText={errors.landmark}
          />

          <TextField
            margin="dense"
            label="Pin code"
            type="tel"
            fullWidth
            value={vendorData?.pincode || ""}
            onChange={(e) =>
              setVendorData({ ...vendorData, pincode: e.target.value })
            }
            disabled
            error={!!errors.pincode}
            helperText={errors.pincode}
          />
        </Box>

        {/* Location Section */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6">Select Location</Typography>

          <TextField
            fullWidth
            margin="dense"
            label="Search Location"
            variant="outlined"
            sx={{ mt: 2 }}
            value={vendorData?.searchlocation}
            onChange={handleLocationSearch}
            disabled
            error={!!errors.searchlocation}
            helperText={errors.searchlocation}
          />

          <Box sx={{ padding: 3 }}>
            {isLoaded ? (
              <GoogleMap
                ref={mapRef}
                onLoad={(map) => {
                  mapRef.current = map;
                  if (vendorData.latitude && vendorData.longitude) {
                    map.panTo({
                      lat: parseFloat(vendorData.latitude),
                      lng: parseFloat(vendorData.longitude),
                    });
                    map.setZoom(15);
                  }
                }}
                center={{
                  lat: parseFloat(vendorData.latitude) || 0,
                  lng: parseFloat(vendorData.longitude) || 0,
                }}
                zoom={13}
                mapContainerStyle={{
                  height: "400px",
                  width: "100%",
                  marginTop: "20px",
                }}
                options={{
                  streetViewControl: false,
                  mapTypeControl: false,
                }}
              >
                <LocationPicker
                  setLatitude={(lat) =>
                    setVendorData((prevData) => ({
                      ...prevData,
                      latitude: lat,
                    }))
                  }
                  setLongitude={(lon) =>
                    setVendorData((prevData) => ({
                      ...prevData,
                      longitude: lon,
                    }))
                  }
                />
                {vendorData.latitude && vendorData.longitude && (
                  <MarkerF
                    ref={markerRef}
                    position={{
                      lat: parseFloat(vendorData.latitude),
                      lng: parseFloat(vendorData.longitude),
                    }}
                    icon={createRedIcon()}
                    onClick={() => setInfoWindowOpen(true)}
                  >
                    {isInfoWindowOpen && (
                      <InfoWindowF
                        position={{
                          lat: parseFloat(vendorData.latitude),
                          lng: parseFloat(vendorData.longitude),
                        }}
                        onCloseClick={() => setInfoWindowOpen(false)}
                      >
                        <div>
                          <p>
                            Latitude: {vendorData.latitude}, Longitude:{" "}
                            {vendorData.longitude}
                          </p>
                        </div>
                      </InfoWindowF>
                    )}
                  </MarkerF>
                )}
              </GoogleMap>
            ) : (
              <Box sx={{ textAlign: "center", p: 3 }}>
                <Typography>Loading map...</Typography>
              </Box>
            )}
          </Box>

          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <TextField
              margin="dense"
              label="Latitude"
              type="text"
              fullWidth
              value={vendorData?.latitude}
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              margin="dense"
              label="Longitude"
              type="text"
              fullWidth
              value={vendorData?.longitude || ""}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
        >
          <Button
            variant="outlined"
            color="error"
            onClick={() => window.history.back()}
          >
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleSubmit}>
            Update
          </Button>
        </Box>
      </Box>

      {/* Success/Error Dialog */}
      <Dialog open={isModalOpen} onClose={handleClose}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProfilePage;
